import { render, staticRenderFns } from "./MainLedgerIndex3.vue?vue&type=template&id=74a228ba&scoped=true"
import script from "./MainLedgerIndex3.vue?vue&type=script&lang=js"
export * from "./MainLedgerIndex3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a228ba",
  null
  
)

export default component.exports